import { useEffect, useState } from "react";

export type PublicConfig = {
  registrationEnabled: boolean;
  authPages?: {
    showLogo: boolean;
    showMessage: boolean;
    messageMarkdown: string;
  };
  /** Dashboard-only fallback; independent of CLI settings. */
  dashboardDefaultLocale?: string | null;
  session?: {
    rememberEnabled: boolean;
    rememberDays: number;
  };
};

type HookState = {
  data?: PublicConfig;
  loading: boolean;
  error?: string;
};

export const usePublicConfig = () => {
  const [state, setState] = useState<HookState>({ loading: true });

  useEffect(() => {
    let active = true;

    const fetchConfig = async () => {
      try {
        const res = await fetch("/api/system/config", {
          headers: { Accept: "application/json" },
          cache: "no-store",
        });
        if (!res.ok) {
          throw new Error(`Request failed (${res.status})`);
        }
        const payload = (await res.json()) as { ok: boolean; config?: PublicConfig };
        if (!active) return;
        setState({ data: payload.config, loading: false });
      } catch (error) {
        if (!active) return;
        const message = error instanceof Error ? error.message : "Unable to load config";
        setState({ loading: false, error: message });
      }
    };

    fetchConfig();

    return () => {
      active = false;
    };
  }, []);

  return state;
};
